import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/Tx_Quots/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/Tx_Quots/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/Tx_Quots/add',
    method: 'post',
    data
  });
}

// 修改开标时间
export function update(data) {
  return request({
    url: '/Tx_Quots/SaveFinish',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/Tx_Quots/delete',
    method: 'post',
    data
  });
}

export function get(paramStr) {
  return request({
    url: '/Tx_Quots/Get',
    method: 'post',
    data: { paramStr }
  });
}

export function getloadfile(data) {
  return request({
    url: '/Tx_Quots/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}

// 发表
export function Publish(data) {
  return request({
    url: '/Tx_Quots/Publish',
    method: 'post',
    data: { paramStr: data }
  });
}

// 撤回
export function Back(data) {
  return request({
    url: '/Tx_Quots/Back',
    method: 'post',
    data: { paramStr: data }
  });
}

